import React, { useCallback } from 'react'
import ConfirmCSVDowloadDialog from '../../ConfirmCSVDowloadDialog.jsx'
import { openModal } from 'actions/modalActions'
import { useDispatch } from 'react-redux'
import useCSV from './useCSV.js'
import DivButton from 'GeneralUI/DivButton/DivButton.jsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const DownloadCSVButton = ({ visible, pageSizeOptions, table, downloadFileName, propsManual, matchesCount, pagination, dataLength }) => {
  const dispatch = useDispatch()
  const { downloadCsvPriv, confirmCSVDownload } = useCSV({ table, downloadFileName, propsManual, matchesCount, pagination, dataLength })

  const confirmCallback = useCallback((rowCount, totalRows, pageSize, tableHasPII, downloadCallback) => {
    const maxPageSize = Math.max(...pageSizeOptions)

    dispatch(openModal('download_partial_data_modal', {
      title: 'Verify Download',
      content: (
        <ConfirmCSVDowloadDialog
          count={rowCount}
          totalRows={totalRows}
          pageSize={pageSize}
          maxPageSize={maxPageSize}
          hasPII={tableHasPII}
          okHandler={downloadCallback}
        />
      ),
      closeable: true
    }))
  }, [pageSizeOptions])

  const downloadCSV = useCallback(() => {
    confirmCSVDownload(confirmCallback)
  }, [confirmCallback, confirmCSVDownload])

  return visible
    ? (
    <DivButton
      className={'btn btn-default control-button'}
      aria-label={'download button'}
      onClick={downloadCSV}
      disabled={!downloadCsvPriv}
      data-toggle={'tooltip'}
      data-title={
        downloadCsvPriv
          ? 'Download CSV'
          : 'The Download CSV privilege within Global is required to perform this action'
      }
    >
      <FontAwesomeIcon icon={['fas', 'download']} size="sm" fixedWidth />
    </DivButton>
      )
    : null
}

export default DownloadCSVButton
